import { TextListItemProps } from './types';

export const itemPropsAreEqual = (prevProps: TextListItemProps, nextProps: TextListItemProps) => {
  return prevProps?.textData === nextProps?.textData &&
    prevProps?.previousTextData === nextProps?.previousTextData &&
    prevProps?.modifiedText === nextProps?.modifiedText &&
    prevProps?.edited === nextProps?.edited &&
    (prevProps?.validationMessages?.length ?? 0) === (nextProps?.validationMessages?.length ?? 0) &&
    (prevProps?.validationMessages || []).every(
      prevMessage => (nextProps?.validationMessages || []).some(nextMessage => prevMessage === nextMessage)
    );
};
